import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IContentComponent } from 'src/app/interfaces/content-component.interface';
import { CaseService } from 'src/app/services/case.service';
import { ContentService } from 'src/app/services/content.service';

@Component({
  selector: 'app-consent',
  templateUrl: './consent.component.html',
  styleUrls: ['./consent.component.scss']
})
export class ConsentComponent implements OnInit, OnDestroy, IContentComponent {

  private componentDestroyed = new Subject();

  pageComponentName: string = 'Consent';
  data!: Map<string, string>;

  caseUId!: string;

  constructor(private caseService: CaseService, private route: ActivatedRoute, private router: Router, private contentService: ContentService) {

    this.route.params
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(
        (params: Params) => {
          this.caseUId = params['id'];

          //TODO: SJEKK TILGANG


        }
      );

    this.contentService.content
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(
        (data: Map<string, string>) => {
          if (data !== undefined) {
            this.data = data;
          }
        }
      );

    this.contentService.loadContent('pageText', this.pageComponentName, ['text', 'label']);

  }

  getLabelValue(label: string): string {
    let value: string = '';
    if (this.data) {
      value = this.data.get(label) ?? '';
    }
    return value;
  }

  ngOnInit() {

  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(null);
    this.componentDestroyed.unsubscribe();
  }

  setConsent(value: boolean) {

    this.caseService.setConsent(value, this.caseUId)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(
        () => {
          if (value) {
            this.router.navigate(['/cases/', this.caseUId]);
          } else {
            this.caseService.closeApplication();
          }
        },
        (error: HttpErrorResponse) => {
          console.log(error);
        },
        () => {
          console.log('Finished save consent for case with id ' + this.caseUId);
        }
      );

  }

}
